<template>
  <el-row justify="center">
    <el-col :xs="24" :sm="20" :md="16" :lg="12">

      <el-card shadow="never">
        <template #header>
          <div class="card-header">
            <h5 class="mb-0">修改密码</h5>
          </div>
        </template>

        <el-alert
          v-if="successMessage"
          :title="successMessage"
          type="success"
          show-icon
          class="mb-3"
          :closable="false"
        >
          <el-button type="success" plain @click="$router.push('/dashboard')">
            返回个人中心
          </el-button>
        </el-alert>
        <el-alert
          v-if="errorMessage"
          :title="errorMessage"
          type="error"
          show-icon
          class="mb-3"
          :closable="false"
        />

        <el-form
          v-if="!successMessage"
          :model="formData"
          :rules="formRules"
          ref="changePassFormRef"
          label-position="top"
          @submit.prevent="handleSubmit"
        >
          <el-form-item label="旧密码" prop="old_password">
            <el-input
              v-model="formData.old_password"
              type="password"
              show-password
            />
          </el-form-item>

          <el-form-item label="新密码" prop="new_password1">
            <el-input
              v-model="formData.new_password1"
              type="password"
              show-password
              placeholder="请输入您的新密码"
            />
          </el-form-item>

          <el-form-item label="确认新密码" prop="new_password2">
            <el-input
              v-model="formData.new_password2"
              type="password"
              show-password
              placeholder="请再次输入新密码"
            />
          </el-form-item>
          <el-form-item class="mt-4">
            <el-button
              type="primary"
              size="large"
              @click="handleSubmit"
              :loading="isLoading"
              class="w-100"
            >
              {{ isLoading ? '正在保存...' : '确认更改密码' }}
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>

    </el-col>
  </el-row>
</template>

<script>
import axios from 'axios';
// 【V4.0 新增】导入 Element Plus 消息提示
import { ElMessage } from 'element-plus';

export default {
  name: 'ChangePasswordView',
  data() {
    // 【V4.0 新增】自定义验证规则
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.formData.new_password1) {
        callback(new Error("两次输入的新密码不一致！"));
      } else {
        callback();
      }
    };

    return {
      // 1. 状态
      isLoading: false,

      // 2. 表单数据
      formData: {
        old_password: '',
        new_password1: '',
        new_password2: '',
      },

      // 3. 提示信息
      successMessage: null,
      errorMessage: null,

      // 4. 【V4.0】 Element Plus 表单验证规则
      formRules: {
        old_password: [
          { required: true, message: '旧密码不能为空。', trigger: 'blur' },
        ],
        new_password1: [
          { required: true, message: '新密码不能为空。', trigger: 'blur' },
          // (Django 的密码强度验证在后端处理)
        ],
        new_password2: [
          { required: true, validator: validatePass2, trigger: 'blur' },
        ],
      }
    };
  },

  methods: {
    /**
     * handleSubmit() (已【重构】为使用 el-form 验证)
     */
    async handleSubmit() {
      // 1. 【V4.0】使用 el-form 的 'validate' 方法
      this.$refs.changePassFormRef.validate(async (valid) => {
        if (!valid) {
          ElMessage({ type: 'error', message: '请检查您的表单是否填写完整。' });
          return false;
        }

        // --- 验证通过, 开始提交 ---
        this.isLoading = true;
        this.successMessage = null;
        this.errorMessage = null;

        const token = localStorage.getItem('authToken');

        try {
          // 2. 【POST】请求 (保持不变)
          await axios.post('/members/api/password/change/', this.formData, {
            headers: { 'Authorization': `Token ${token}` }
          });

          // 3. 处理成功
          this.successMessage = '密码修改成功！您可以返回个人中心。';
          this.$refs.changePassFormRef.resetFields(); // 清空表单

        } catch (error) {
          // 4. 处理失败
          console.error('修改密码失败:', error);
          if (error.response && error.response.data) {
            // 将后端返回的所有错误信息合并显示
            let errors = [];
            for (const key in error.response.data) {
              errors.push(error.response.data[key].join(' '));
            }
            this.errorMessage = `操作失败：${errors.join(' ')}`;
          } else {
            this.errorMessage = '操作失败，发生未知错误。';
          }
        } finally {
          // 5. 结束“提交”状态
          this.isLoading = false;
        }
        // --- 提交结束 ---
      });
    }
  }
};
</script>

<style scoped>
/* --- V4.0 样式 --- */
.w-100 {
  width: 100%;
}
.card-header h5 {
  font-weight: 600;
  margin-bottom: 0;
}
.mb-3 {
  margin-bottom: 1.25rem;
}
.mt-4 {
  margin-top: 1.5rem;
}
.me-2 {
  margin-right: 0.5rem;
}
</style>